<template>
    <div class="overflow-hidden bg-white">
        <div class="pt-6 pb-12">
            <div class="items-center max-w-full m-auto mt-8 text-center md:pt-24 sm:px-6 md:px-24">
                <h1 class="text-3xl font-bold text-gray-800 md:text-4xl">
                    The <span class="whitespace-no-wrap">progress tracker</span> <br class="xl:hidden" />
                    for
                    <span class="relative">
                        <svg class="absolute right-0 w-56 h-20 fill-current md:w-64 top-1 text-primary-500" viewBox="0 0 47 4">
                            <path d="M1 2.4C1 2 35.1209 2 46 1" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1 2C18.3783 2 37.5 1.5 45.5 2" stroke="currentColor" stroke-width="0.4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="relative whitespace-no-wrap">
                            remote teams
                        </span>
                    </span>
                </h1>
                <p class="max-w-md mx-auto mt-3 text-lg font-medium text-gray-500 md:text-xl md:mt-5">
                    Work collaborativly with your team.<br />
                    Get more done, anywhere.
                </p>
                <div class="max-w-md px-4 mx-auto mt-14 sm:flex sm:justify-center md:px-0">
                    <div class="rounded-md shadow">
                        <a
                            href="https://beta.flowist.io/signup"
                            class="flex items-center justify-center w-full px-8 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo md:py-4 md:text-lg md:px-10"
                            >Try it for free</a
                        >
                    </div>
                </div>
            </div>
            <div class="relative p-8 mt-8">
                <div class="absolute inset-0 flex flex-col">
                    <div class="flex-1"></div>
                    <div class="flex-1 w-full"></div>
                </div>
                <div class="max-w-screen-xl px-0 mx-auto sm:px-6">
                    <img class="relative border rounded-lg shadow-xl" src="../assets/full-mock.svg" alt="App screenshot" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'app-hero',
};
</script>
<style></style>
